module.exports = __webpack_public_path__ + "img/softinya-4.5303c975.png";